function dateOnly(date) {
	return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`
}

export function createSelfMonitoringConfig() {
	return {
		title: "Self-Monitoring Form",
		instructions: "Record each episode soon afterward. Briefly describe the situation, activity, or thought; any overt or mental ritual; and time spent on the ritual.",
		reviewFocus: "Review triggers, intensity, rituals, and time spent to choose ERP targets.",
		reviewNotesLabel: "Private practitioner notes",
		groupingLabel: "Practitioner grouping",
		durationFieldId: "minutes",
		durationSummaryLabel: "Ritual time",
		entryLabel: "Episode",
		trackerKind: "episodeLog",
		periodStartDate: "",
		periodEndDate: "",
		ratingScaleMax: 100,
		ratingScaleMin: 0,
		fields: [
			{id: "date", title: "Date", type: "date"},
			{id: "time", title: "Time of day", type: "time"},
			{id: "trigger", title: "Situation, activity, or thought that evoked distress and the urge to ritualize", type: "text"},
			{id: "suds", title: "SUDS", type: "rating"},
			{id: "ritual", title: "Description of ritual", type: "text"},
			{id: "minutes", title: "Minutes spent on ritual", type: "minutes"},
		],
		archivedFields: [],
	}
}

export function createSelfMonitoringDemoPayload() {
	let tracker = createSelfMonitoringConfig()
	let firstDate = new Date()
	firstDate.setDate(firstDate.getDate() - 5)
	let secondDate = new Date()
	secondDate.setDate(secondDate.getDate() - 2)
	return {tracker, entries: [
		{id: "episode-1", answers: {date: dateOnly(firstDate), time: "09:10", trigger: "Left home", suds: 65, ritual: "Checked the lock twice", minutes: 4}},
		{id: "episode-2", answers: {date: dateOnly(secondDate), time: "14:30", trigger: "Read an email", suds: 40, ritual: "Repeated a phrase mentally", minutes: 6}},
	]}
}

export function createSelfMonitoringDemoConfig() {
	let config = createSelfMonitoringConfig()
	let start = new Date()
	start.setDate(start.getDate() - 6)
	config.periodStartDate = dateOnly(start)
	config.periodEndDate = dateOnly(new Date())
	return config
}

